export const NOTIFICATIONS_CONTAINER_TAG_NAME = 'notifications-container';
